import { render, staticRenderFns } from "./saveTag.vue?vue&type=template&id=3a63a647&"
import script from "./saveTag.vue?vue&type=script&lang=js&"
export * from "./saveTag.vue?vue&type=script&lang=js&"
import style0 from "./saveTag.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports